const P2PSenderViewModelTypeName = "P2PSenderViewModel";
const P2PSenderTypeName = "P2PSender";
const P2PLimitsTypeName = "P2PLimits";
const P2PLimitsViewModelTypeName = "P2PLimitsViewModel";
const P2PLimitsInputTypeName = "P2PLimitsInput";
const P2PGlobalSettingsViewModelKeysTypeName = "P2PGlobalSettingsViewModelKeys";
const P2PGlobalSettingsModelTypeName = "P2PGlobalSettingsModel";
const P2PGlobalSettingsViewModelTypeName = "P2PGlobalSettingsViewModel";
const P2PGlobalSettingsQueryFieldsTypeName = "P2PGlobalSettingsQueryFields";
export {
  P2PGlobalSettingsModelTypeName,
  P2PGlobalSettingsQueryFieldsTypeName,
  P2PGlobalSettingsViewModelKeysTypeName,
  P2PGlobalSettingsViewModelTypeName,
  P2PLimitsInputTypeName,
  P2PLimitsTypeName,
  P2PLimitsViewModelTypeName,
  P2PSenderTypeName,
  P2PSenderViewModelTypeName
};
//# sourceMappingURL=constants.js.map
